"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IChain = exports.StreamType = exports.StreamDirection = exports.ICluster = void 0;
// Utility types
var ICluster;
(function (ICluster) {
    ICluster["Mainnet"] = "mainnet";
    ICluster["Devnet"] = "devnet";
    ICluster["Testnet"] = "testnet";
    ICluster["Local"] = "local";
})(ICluster = exports.ICluster || (exports.ICluster = {}));
var StreamDirection;
(function (StreamDirection) {
    StreamDirection["Outgoing"] = "outgoing";
    StreamDirection["Incoming"] = "incoming";
    StreamDirection["All"] = "all";
})(StreamDirection = exports.StreamDirection || (exports.StreamDirection = {}));
var StreamType;
(function (StreamType) {
    StreamType["All"] = "all";
    StreamType["Payment"] = "payment";
    StreamType["Vesting"] = "vesting";
    StreamType["Lock"] = "lock";
})(StreamType = exports.StreamType || (exports.StreamType = {}));
var IChain;
(function (IChain) {
    IChain["Solana"] = "Solana";
    IChain["Aptos"] = "Aptos";
    IChain["Ethereum"] = "Ethereum";
    IChain["BNB"] = "BNB";
    IChain["Polygon"] = "Polygon";
    IChain["Sui"] = "Sui";
})(IChain = exports.IChain || (exports.IChain = {}));
